<template>
      <div class="store-container relative page__inner">
        <div class="absolute inset-0 z-[-1] bg-gray-400/60"/>
        <!-- inner container -->
        <div
          role="status"
          class="relative py-2 pt-7 pb-10 lg:pb-12 xl:pb-20 mt-5 bg-[#f5f5f5] page__inner w-full flex justify-center"
        >
          <div class="store-inner w-full page__inner">
            <div class="flex gap-2">
              <div v-for="(_, index) in Array.from({length: 2})" :key="index">
                <div class="animate-pulse h-3 w-[70px] bg-gray-200 dark:bg-gray-700 rounded-full mb-3" />
              </div>
            </div>

            <!-- top area -->
            <div class="flex justify-end">
            </div>
            <!-- store info -->
            <section
              class="bg-[#fff] relative hidden lg:flex w-full rounded-[11px] min-h-[180px] justify-between p-5 px-3 md:px-5 lg:px-8 mt-12"
            >
              <div
                class="lg:basis-[33.3%] w-full"
              >
                <!-- categories -->
                <div
                  class="animate-pulse bg-gray-200 dark:bg-gray-700 h-3 w-[50px] mb-2"
                ></div>
                <ul class="list-none animate-pulse flex flex-wrap items-center mt-1 gap-1">
                  <li
                    v-for="(_, index) in Array.from({length: 3})"
                    :key="index"
                    class="bg-gray-300/50 dark:bg-gray-300 h-[27px] w-[80px] rounded-[5px]"
                  />
                </ul>
              </div>
              <div class="lg:basis-[33.3%]"></div>
              <!-- middle -->

              <div
                class="flex flex-col absolute left-[50%] translate-x-[-50%] top-[-70px] items-center w-[140px]"
              >
                <span
                  class="bg-gray-300 mb-2 rounded-full animate-pulse dark:bg-gray-700 select-none w-[140px] h-[140px] 3xl:w-[150px] 3xl:h-[150px]"
                  width="140"
                  height="140"
                />
                <div
                  class="mt-2 animate-pulse h-[10px] w-[80px] rounded-sm bg-gray-200 dark:bg-gray-700"
                />
              </div>
              <div
                class="absolute left-[50%] animate-pulse h-[36px] w-[170px] bg-gray-200 dark:bg-gray-700 text-[16.5px] font-bold py-1.5 px-3 sm:px-5 md:px-8 xl:px-9 gap-1.5 flex flex-nowrap rounded-[22px] translate-x-[-50%] bottom-[-10px]"
              >
              </div>
              <div class="w-full lg:basis-[33.3%] lg:flex flex-col lg:items-end">
                <div>
                  <div
                    class="animate-pulse bg-gray-200 dark:bg-gray-700 h-[55px] w-[55px]"
                    :size="55"
                  />
                </div>
                <ul class="list-none flex flex-wrap mt-5 gap-2 md:gap-2.5">
                  <li v-for="(_, index) in Array.from({length: 5})" :key="index">
                      <div
                        class="animate-pulse bg-gray-200 dark:bg-gray-700 w-[30px] h-[30px] rounded-full"
                      />
                  </li>
                </ul>
              </div>
            </section>
            <!--  store info on mobile -->
            <section
              class="bg-[#fff] lg:hidden relative flex flex-col w-full rounded-[11px] min-h-[180px] items-center p-5 px-3 md:px-5 lg:px-8 mt-1"
            >
              <!--  -->
              <div class="flex flex-col items-center w-full">
                <span
                  class="bg-gray-300 mb-2 rounded-full animate-pulse dark:bg-gray-700 select-none w-[120px] h-[120px] 3xl:w-[150px] 3xl:h-[150px]"
                  width="120"
                  height="120"
                />
                <div
                  class="mt-2 animate-pulse h-[18px] w-[80px] bg-gray-200 dark:bg-gray-700"
                />
              </div>
              <div
                class="animate-pulse mt-3 h-[32px] w-[140px] bg-gray-200 dark:bg-gray-700 rounded-[22px]"
              >
              </div>
              <ul class="list-none flex flex-wrap mt-5 gap-2 md:gap-2.5">
                  <li v-for="(_, index) in Array.from({length: 5})" :key="index">
                      <div
                        class="animate-pulse bg-gray-200 dark:bg-gray-700 w-[30px] h-[30px] rounded-full"
                      />
                  </li>
                </ul>
              <div
                class="w-full flex flex-col items-center"
              >
                <!-- categories -->
                <ul class="list-none flex flex-wrap items-center mt-4 gap-1">
                  <li
                    v-for="(_, index) in Array.from({length: 3})"
                    :key="index"
                    class="bg-gray-300/50 dark:bg-gray-300 h-[27px] w-[80px] rounded-[5px]"
                  />
                </ul>
              </div>
            </section>
            <!-- store location & description -->
            <section class="flex flex-wrap md:flex-nowrap mt-5 md:mt-7 gap-y-4 gap-x-7">
              <!-- description -->
              <div class="w-full md:w-1/2 p-2 rounded-[11px] bg-white">
                <div class="py-4 px-3">
                    <div class="animate-pulse bg-gray-200 dark:bg-gray-700 h-3 w-[50px] mb-2"/>
                    <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[30%] mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[100%] mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[100%] mb-2.5"></div>
                    <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[60%]"></div>
                </div>
              </div>
              <!-- address -->
              <div class="w-full md:w-1/2 p-2 rounded-[11px] bg-white">
                <div class="flex flex-wrap lg:flex-nowrap justify-between items-centerd h-full">
                  <div class="py-2 w-full md:p-4 lg:w-1/2">
                    <div class="py-4 px-3 w-full">
                        <div class="animate-pulse bg-gray-200 dark:bg-gray-700 h-3 w-[50px] mb-2"/>
                        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[100%] mb-2.5"></div>
                        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[100%] mb-2.5"></div>
                        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[60%] mb-2.5"></div>
                    </div>
                  </div>
                  <div
                    class="relative animate-pulse bg-gray-200 dark:bg-gray-700 w-full flex justify-center lg:w-1/2 min-h-[130px] rounded-[5px]"
                  />
                </div>
              </div>
            </section>
            <!-- store branches -->
            <div>
              <div class="my-7 animate-pulse bg-gray-200 dark:bg-gray-700 h-3.5 w-[50px] sm-[70px] md:w-[90px]"/>
              <ul class="flex w-full overflow-hidden flex-nowrap items-center gap-2">
                <li v-for="(_, index) in Array.from({ length: 7 })" :key="index">
                  <div
                    role="status"
                    class="flex store-item animate-pulse bg-white cursor-pointer flex-col p-3 w-[150px] mx-1 md:w-[160px] text-center items-center justify-center border border-[#E2E2E2]">
                    <div
                      class="w-[80px] image-container bg-gray-300 rounded-full dark:bg-gray-700 mb-4 select-none h-[80px] lg:w-[85px] lg:h-[85px] overflow-hidden" />
                    <span class="text-[13px] bg-gray-100 h-[19px] w-[70%] font-bold mt-0 mb-2 text-[#000000]" />
                    <span class="text-[12px] w-full p-2 mb-1 bg-gray-200 h-[28px] text-center font-normal bg-[#0963FF29] text-[#2955A1] rounded-[150px]" />
                  </div>
                </li>
              </ul>
            </div>

            <!-- filter products -->
            <div class="w-full flex sm:flex-row flex-col gap-8 gap-y-3 mt-10 mb-3 md:mb-6">
              <!-- filter by search -->
                <div class="animate-pulse h-[47px] w-full nd:w-[70%] bg-gray-200/70 rounded-[5px] dark:bg-gray-700"/>
                <div class="animate-pulse h-[47px] w-full md:w-[30%] bg-gray-200/70 rounded-[5px] dark:bg-gray-700"/>
            </div>
            <div>
                <div class="my-7 animate-pulse bg-gray-200 dark:bg-gray-700 h-3.5 w-[50px] sm-[70px] md:w-[90px]"/>
                <ul class="products-items-list">
                <li v-for="(_, index) in Array.from({length: 5})" :key="index">
                        <div   class="h-[288px] animate-pulse card__two min-w-[130px] w-full border border-[#DEDEDE] rounded-[7px] overflow-hidden">
                            <!-- visual info -->
                            <div class="relative">
                                <!-- store bar -->
                                <div class="bg-gray-200 absolute top-0 left-0 w-full py-2 px-3 text-[#FFFFFF] text-[11px] sm:text-[12px] 3xl:text-[13px] font-normal flex flex-nowrap items-center gap-1.5">
                                    <span class="store__logo rounded-full p-1 grid bg-gray-300 place-items-center w-[22px] h-[22px] sm:w-[23px] sm:h-[23px] 3xl:w-[24px] 3xl:h-[24px]"/>
                                    <span class="overflow-hidden whitespace-nowrap text-ellipsis bg-gray-300 h-[12px] w-[52px]"/>
                                </div>
                                <!-- product image -->
                                <div class="z-0 bg-gray-100 h-[179px] w-[100%]"/>
                                <!-- product rating -->
                                <span class="gap-1.5 bg-gray-300 absolute bottom-2.5 w-[56px] h-[25px] rtl:left-2 rtl:right-auto left-auto right-2 text-[#FFFFFF] text-[12px] sm:text-[13px] 3xl:text-[14px] flex items-center rounded-[6px]">
                                    <strong/>
                                </span>
                            </div>
                            <div class="px-3">
                                <!-- price, description, favorite and production date -->
                                <div>
                                    <div class="flex items-center h-[40px] justify-between w-full">
                                        <!-- price -->
                                        <div class="text-[17px] sm:text-[18px] 3xl:text[19px] flex items-center gap-1">
                                            <strong class="bg-gray-200 w-[77px] h-[16px] font-bold"/>
                                            <span class="bg-gray-100 w-[23px] h-[8px]"/>
                                        </div>
                                        <div>
                                        <!-- favorite -->
                                        <span class="bg-transparent  border-0 px-2">
                                        <img class="object-contain" :src="unfavedIcon" alt=""/>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- description -->
                                <div class="px-2 bg-gray-200 w-[90%] h-[30px] h font-normal text-[13px] text-black product-description ellipsis-x2 sm:text-[14px] 3xl:text-[15px]">
                                    <p class=" transition-all duration-150"/>
                                </div>
                                <!-- date -->
                                <div class="px-2 bg-gray-200 w-[70%] mt-3 h-[11px]"/>  
                            </div>

                        </div>
                </li>
                </ul>   
            </div>
          </div>
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </div>
</template>

<script>
import unfavedIcon from "@/assets/images/heart-unfaved.svg";
export default {
  data(){
      return{
        unfavedIcon
      }
  },
}
</script>

<style>

</style>